import store from '../redux/store';
import { changeSystemStatus } from '../redux/global/actions';

export const getSearchParameters = () => {
  const paramStr = window.location.search.substring(1);
  return paramStr != null && paramStr !== ''
    ? transformToParamMap(paramStr)
    : {};
};

export const transformToParamMap = paramStr => {
  const paramMap = {};
  const params = paramStr.split('&');
  params.forEach(param => {
    const [key, value] = param.split('=');
    paramMap[key] = value;
  });

  return paramMap;
};

export const getSystemStatus = async () => {
  try {
    const response = await fetch(process.env.REACT_APP_SYSTEM_STATUS_URL);
    if (response.ok) {
      const systemStatus = await response.json();
      const data = {
        isSystemDown:
          systemStatus.isPlannedMaintenance ||
          systemStatus.isUnplannedMaintenance ||
          systemStatus.isAcknowledgedDowntime,
        restoreDate: systemStatus.estimateTimeForNormalization,
      };

      store.dispatch(changeSystemStatus(data));

      return data;
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('cannot fetch system status');
  }

  return {
    isSystemDown: false,
    restoreDate: null,
  };
};

export const getFormattedDate = date => {
  const year = date.getFullYear();

  let month = (1 + date.getMonth()).toString();
  month = month.length > 1 ? month : `0${month}`;

  let day = date.getDate().toString();
  day = day.length > 1 ? day : `0${day}`;

  return `${month}/${day}/${year}`;
};
